import { FC, useMemo } from "react";
import { SelectInputField } from "@vilocnv/allsetra-core";
import { useTranslation } from "react-i18next";
import { KeyStatus } from "domain/keys/entities/dtos/key-history.dto";

export interface KeyStatusFilterProps {
  value: KeyStatus | "all";
  onChange: (value: KeyStatus | "all") => void;
}

const KeyStatusFilter: FC<KeyStatusFilterProps> = ({ value, onChange }) => {
  const { t } = useTranslation(["translation"]);

  const options = useMemo(
    () => [
      { label: t("keyStatusFilter.all"), value: "all" },
      { label: t("keyStatusFilter.active"), value: KeyStatus.Active },
      { label: t("keyStatusFilter.inventory"), value: KeyStatus.Inventory },
      { label: t("keyStatusFilter.blocked"), value: KeyStatus.Blocked },
      { label: t("keyStatusFilter.deleted"), value: KeyStatus.Deleted }
    ],
    [t]
  );

  const handleChange = (newValue: KeyStatus | "all") => {
    onChange(newValue === "all" ? "all" : (newValue as KeyStatus));
  };

  return (
    <SelectInputField
      name="keyStatusFilter"
      options={options}
      optionLabelKey="label"
      optionValueKey="value"
      value={value}
      onChange={handleChange}
      sx={{ width: 135 }}
    />
  );
};

export default KeyStatusFilter;
